import { shallowEqual, useSelector } from 'react-redux'

import { ActionBarLeft, ActionBarRight, ActionBarWrapper } from '@components/UI/Card/Card.styled'
import { useInboxFilter } from '@hooks/useInboxFilter'
import { IApplicationState } from '@store/index'
import { ISubmission, selectComparisonLink } from '@store/submissions'
import ActionBarIconChat from '../Icon/Chat'
import ActionBarIconCompareSubmission from '../Icon/CompareSubmission/CompareSubmission'
import ActionBarIconDecline from '../Icon/Decline/Decline'
import ActionBarIconPurchaseLicense from '../Icon/PurchaseLicense/PurchaseLicense'
import ActionBarIconShortlist from '../Icon/Shortlist/Shortlist'
import ActionBarIconUnshortlist from '../Icon/Unshortlist/Unshortlist'

interface IProps {
  submission: ISubmission
  campaignId: number
  hasShortlistLink: boolean
  hasUnshortlistLink: boolean
  hasDeclineLink: boolean
  hasFeedbackLink: boolean
  showLicenseIcon: boolean
}

const SubmissionCardActionBarContentInbox: React.FC<IProps> = ({
  hasShortlistLink,
  hasUnshortlistLink,
  hasDeclineLink,
  hasFeedbackLink,
  campaignId,
  submission,
  showLicenseIcon,
}) => {
  const { currentFilter } = useInboxFilter()
  const { hasComparisonLink } = useSelector((state: IApplicationState) => ({
    hasComparisonLink: selectComparisonLink(state, submission.id),
  }), shallowEqual)

  const modalProps = {
    currFilter: currentFilter,
    submission,
    campaignId,
  }

  const submissionId = submission.id

  return (
    <ActionBarWrapper justifyBetween>
      <ActionBarLeft>
        {hasShortlistLink && <ActionBarIconShortlist submissionId={submissionId} />}
        {hasUnshortlistLink && <ActionBarIconUnshortlist submissionId={submissionId} />}
        {hasFeedbackLink && <ActionBarIconChat submission={submission} campaignId={campaignId} />}
        {hasComparisonLink && (
          <ActionBarIconCompareSubmission submissionId={submissionId} campaignId={campaignId} />
        )}
      </ActionBarLeft>
      <ActionBarRight>
        {hasDeclineLink && <ActionBarIconDecline modalProps={modalProps} />}
        {showLicenseIcon && <ActionBarIconPurchaseLicense submissionId={submissionId} />}
      </ActionBarRight>
    </ActionBarWrapper>
  )
}

export default SubmissionCardActionBarContentInbox
